var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var bcSfFilterSettings = {
  general: {
    limit: bcSfFilterConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: false
  }
};
// Declare Templates
var bcSfFilterTemplate = {
  'soldOutClass': ' sold-out',
  'saleClass': ' on-sale',
  'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
  'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
  'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
  'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',
  // Pagination Template
  'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
  'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
  'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
  'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
  'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
  'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
  // Sorting Template
  'sortingHtml': '<label for="bc-filter-sorting">' + bcSfFilterConfig.label.sorting + '</label><select name="bc-filter-sorting" class="bc-sf-filter-filter-dropdown">{{sortingItems}}</select>',
  // Show Limit Template
  'showLimitHtml': '<label for="bc-filter-show-limit">' + bcSfFilterConfig.label.show_limit + '</label><select name="bc-filter-show-limit" class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
  // Breadcrumb Template
  'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
  'breadcrumbDivider': '<span class="divider">/</span>',
  'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
  'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function (e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
  return '';
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
  return '';
};


BCSfFilter.prototype.buildProductList = function (data, eventType) {
  if (eventType != 'sort' && eventType != 'history' && eventType != 'init') {
    theme.ProductFilterAndSearch.onFilterSelected()
  }

  // if(eventType == 'init') {
  //   theme.ProductFilterAndSearch.loadSubcollectionView();
  // } else
  if ($('.subcollection-bar').length > 0 && eventType == 'init') {
    // theme.ProductFilterAndSearch.loadSubcollectionView();
    // $('.bc-sf-filter-filter-dropdown').val("type")
  }

  if ($('.subcollection-bar').length > 0 && location.href.includes('_=pf') == false && location.href.includes('sort=type')) {
    theme.ProductFilterAndSearch.loadSubcollectionView();
  }
  else if (0 == this.loadProductFirst || this.isSearchPage() || this.isVendorPage() || this.isTagPage() || "best-selling" == this.defaultSorting || 1 == this.getSettingValue("general.productAndVariantAvailable") || 1 == this.loadProductFirst && ("init" != eventType || window.location.search.length > 0)) {
    data = this.prepareProductData(data);

    if (this.getSettingValue('general.paginationType') == 'infinite' && eventType == 'page') {
      theme.current.collection.products = _.concat(theme.current.collection.products, data);
    } else {
      theme.current.collection.products = data;
    }
    theme.ProductFilter.buildCollectionPage(data, eventType);
  }
  if (window.StampedFn) StampedFn.loadBadges();
}

/************************** END BUILD PRODUCT LIST **************************/

/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
      window.scrollTo(0,0);
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function () {
  var itemHtml = '<span>' + bcSfFilterConfig.label.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function () {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function (e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function () {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function (colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/

function thePerfectShoe(data , eventType, data_id){
  // THE PERFECT SHOE FEATURE
  function isParameterInURL(parameterName) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.has(parameterName);
  }

const parameterNameToCheck = "pf_t_choose_your_discipline";
const parameterExists = isParameterInURL(parameterNameToCheck);

$('.bc-sf-filter-option-block-choose-your-discipline .bc-sf-filter-block-title').clone().appendTo('#shoe-finder-step-1');
$('.bc-sf-filter-option-block-choose-your-discipline .bc-sf-filter-option-box').clone().appendTo('#shoe-finder-step-1');

// option values update the text to remove prefixes
const optionValues = document.querySelectorAll(".bc-sf-filter-option-value");

optionValues.forEach(function(item) {
    const text = item.textContent.trim();
    const parts = text.split("::");
    if (parts.length > 1) {
        item.textContent = parts[1].trim();
    }
});

// load the slider
$('.shoe_finder_filters').slick({
  dots: true,
  infinite: false,
  draggable:false,
  swipe:false,
  arrows: false,
  speed: 600,
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        arrows: false,
        swipe:false,
        infinite: false,
        draggable:false,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        swipe:false,
        infinite: false,
        draggable:false,
        slidesToShow: 1
      }
    }
  ]
});
// check URL Parameters on load / refresh to load the slider again and keep the position
const slide = $('.shoe_finder_filters').find(`.slick-slide`);
const slideId = slide.attr('id');
$(slide).find(".bc-sf-filter-option-box").each(function() {
  const $ul = $(this);
  const firstDataId = $ul.find("li:first a").data("id");
  //console.log("firstDataId:" , firstDataId)

});



function handleClonedElementClicks() {

  $('[data-id="pf_t_choose_your_discipline"][data-value="Running"]').on("click", function() {
    //add the tick after next slide
    const parentElement =  $('#slick-slide-control20').parent();
    parentElement.addClass("highlighted");
    $('#type_of_terrain').hide();
    $('#type_of_run').toggleClass("hidden");
    $('.type_run.next_step').toggleClass("hidden");
    $('.bc-sf-filter-option-block-what-s-your-favourite-type-of-run  .bc-sf-filter-block-title').clone().appendTo('#type_of_run');
    $('.bc-sf-filter-option-block-what-s-your-favourite-type-of-run .bc-sf-filter-option-box').clone().appendTo('#type_of_run');
    handleClonedElementClicks()
    $('.shoe_finder_filters').slick('slickNext');

  });

$('[data-id="pf_t_choose_your_discipline"][data-value="Trail%20Running"]').on("click", function() {
  //add the tick after next slide
  const parentElement =  $('#slick-slide-control20').parent();
  parentElement.addClass("highlighted");
  $('#type_of_terrain').toggleClass("hidden");
  $('#type_of_run').hide();
  $('.type_terrain.next_step').toggleClass("hidden");
  $('.bc-sf-filter-option-block-what-type-of-terrain-do-you-run-on .bc-sf-filter-block-title').clone().appendTo('#type_of_terrain');
  $('.bc-sf-filter-option-block-what-type-of-terrain-do-you-run-on .bc-sf-filter-option-box').clone().appendTo('#type_of_terrain');

  handleClonedElementClicks()
  $('.shoe_finder_filters').slick('slickNext');
});
$('[data-id="pf_t_what_type_of_terrain_do_you_run_on"]').on("click", function() {
  const parentElement =  $('#slick-slide-control21').parent();
  parentElement.addClass("highlighted");
  //console.log("here click type of terrain");
  $('#shoe-finder-step-3').empty();
  $('.bc-sf-filter-option-block-how-often-do-you-run-per-week  .bc-sf-filter-block-title').clone().appendTo('#shoe-finder-step-3');
  $('.bc-sf-filter-option-block-how-often-do-you-run-per-week .bc-sf-filter-option-box').clone().appendTo('#shoe-finder-step-3');
  handleClonedElementClicks()
  $('.shoe_finder_filters').slick('slickNext');
});
$('[data-id="pf_t_what_s_your_favourite_type_of_run"]').on("click", function() {
  const parentElement =  $('#slick-slide-control21').parent();
  parentElement.addClass("highlighted");
  $('#shoe-finder-step-3').empty();
  //console.log("here click favorite type of run")
  $('.bc-sf-filter-option-block-how-often-do-you-run-per-week  .bc-sf-filter-block-title').clone().appendTo('#shoe-finder-step-3');
  $('.bc-sf-filter-option-block-how-often-do-you-run-per-week .bc-sf-filter-option-box').clone().appendTo('#shoe-finder-step-3');
  handleClonedElementClicks()
  $('.shoe_finder_filters').slick('slickNext');
});

$('[data-id="pf_t_how_often_do_you_run_per_week"]').on("click", function() {
  const parentElement =  $('#slick-slide-control22').parent();
  parentElement.addClass("highlighted");
  $('#shoe-finder-step-4').empty();
  $('.bc-sf-filter-option-block-what-level-of-cushioning-do-you-prefer .bc-sf-filter-block-title').clone().appendTo('#shoe-finder-step-4');
  $('.bc-sf-filter-option-block-what-level-of-cushioning-do-you-prefer .bc-sf-filter-option-box').clone().appendTo('#shoe-finder-step-4');
  handleClonedElementClicks()
  $('.shoe_finder_filters').slick('slickNext');
});
}
handleClonedElementClicks();

// Get the clicked element and its content for dots
$('.shoe_finder_filters').on('click', '.slick-dots', function(event) {
  const clickedElement = $(this);
  const clickedContent = clickedElement.html();
  var slideClicked = $(this).find(".slick-active button").attr("id");

  $('.slick-dots li').each(function(index, element) {
    var element_id = $(this).find("button").attr("id");
    if(element_id === slideClicked){
      $(element).removeClass("highlighted").nextAll().removeClass("highlighted");
      const currentSlideIndex = $('.shoe_finder_filters').slick('slickCurrentSlide');
      const slidesToShow = clickedElement[0].childElementCount
      // Calculate the last slide index
      const lastSlideIndex = slidesToShow - currentSlideIndex + 1;
      // Iterate through slides starting from the current slide until the last slide
      for (let index = currentSlideIndex; index <= lastSlideIndex; index++) {
          const slide = $('.shoe_finder_filters').find(`[data-slick-index="${index}"]`);
          const slideId = slide.attr('id');
          $(slide).find(".bc-sf-filter-option-box").each(function() {
            const $ul = $(this);
            const firstDataId = $ul.find("li:first a").data("id");
            //console.log("First data-id for ul:", firstDataId , index);
            // call event to clear filters if user back to a previous tab
            if (index === 0){
              clearAllFilterOptions(event)
              location.reload();
            }else{
              clearFilterOption(event, this, firstDataId);
              if ($ul.find("a.selected").length > 0) {
                // If there's a selected <a>, remove the "selected" class
                $ul.find("a.selected").removeClass('selected');
              }
              $('.next_step').addClass("disabled");
            }
          });
      }
    }
  });

});
// update states on refresh
function updateDivBasedOnParameters(event) {
  const urlParams = new URLSearchParams(window.location.search);
  let pfParamCount = 0;
  let pf_tParamValue = null;

  urlParams.forEach((value, key) => {
    if (key.startsWith('pf_t')) {
      pfParamCount++;
      pf_tParamValue = value;
    }
  });

}
updateDivBasedOnParameters();
//END THE PERFECT SHOE FEATURE
};


async function fetchRelatedProducts(data){
  const productStitchingElement = document.querySelector(`.product-stitching[product-id="${data.id}"]`);

  if (productStitchingElement) {
    productStitchingElement.innerHTML = await theme.ProductSiblings.generateSiblingHtml(data);
  } else {
    console.warn(`Element with class 'product-stitching' and product-id '${data.id}' not found.`);
  }
}

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {



  if (eventType === 'init'){
    thePerfectShoe(data , eventType);
     console.log("here inside INIT", data, eventType)

  }else if(eventType === 'tag' ){
     console.log("here TAG", data, eventType)

     const resultDiv_1 = $(".result_tags .results");
     resultDiv_1.empty();

     if (resultDiv_1){
      if (data.total_product > 1){
        resultDiv_1.append(data.total_product + ' Results ' + ' ')
      }else if(data.total_product === 1){
        resultDiv_1.append(data.total_product + ' Result ' + ' ')

      }

    }

    function handleClonedElementClicks() {
      $('#type_of_run').empty()
      $('.bc-sf-filter-option-block-what-s-your-favourite-type-of-run  .bc-sf-filter-block-title').clone().appendTo('#type_of_run');
      $('.bc-sf-filter-option-block-what-s-your-favourite-type-of-run .bc-sf-filter-option-box').clone().appendTo('#type_of_run');

      var a_buttons = document.querySelectorAll("#type_of_run a.selected");
      if(a_buttons.length > 0){
        var next_step_button_1 =  document.querySelector('#shoe-finder-step-2 .type_run.next_step');
        next_step_button_1.classList.remove('disabled');
      }else{
        var next_step_button_1 =  document.querySelector('#shoe-finder-step-2 .type_run.next_step');
        next_step_button_1.classList.add('disabled');
      }



      $('#type_of_terrain').empty()
      $('.bc-sf-filter-option-block-what-type-of-terrain-do-you-run-on .bc-sf-filter-block-title').clone().appendTo('#type_of_terrain');
      $('.bc-sf-filter-option-block-what-type-of-terrain-do-you-run-on .bc-sf-filter-option-box').clone().appendTo('#type_of_terrain');
      // var newLiElement = $('<li><a  data-id="pf_t_what_type_of_terrain_do_you_run_on" data-value="all" data-parent-label="What type of terrain do you run on?" class="bc-sf-filter-option-item bc-sf-filter-option-label " data-title="all" data-count="0" rel="nofollow" data-collection-scope="all"><span></span><span class="bc-sf-filter-option-value">Next Step</span><span class="bc-sf-filter-option-amount"></span></a></li>');
      // $('#type_of_terrain .bc-sf-filter-option-box').append(newLiElement);
      var a_buttons_terrain = document.querySelectorAll("#type_of_terrain a.selected");
      if(a_buttons_terrain.length > 0){
        console.log("here selected type of terrain", a_buttons_terrain)
        var next_step_button =  document.querySelector('#shoe-finder-step-2 .type_terrain.next_step');
        next_step_button.classList.remove('disabled');
      }else{
        var next_step_button =  document.querySelector('#shoe-finder-step-2 .type_terrain.next_step');
        next_step_button.classList.add('disabled');

      }



      $('#shoe-finder-step-3').empty()
      $('.bc-sf-filter-option-block-how-often-do-you-run-per-week  .bc-sf-filter-block-title').clone().appendTo('#shoe-finder-step-3');
      $('.bc-sf-filter-option-block-how-often-do-you-run-per-week .bc-sf-filter-option-box').clone().appendTo('#shoe-finder-step-3');

      $('#shoe-finder-step-4').empty()
      $('.bc-sf-filter-option-block-what-level-of-cushioning-do-you-prefer .bc-sf-filter-block-title').clone().appendTo('#shoe-finder-step-4');
      $('.bc-sf-filter-option-block-what-level-of-cushioning-do-you-prefer .bc-sf-filter-option-box').clone().appendTo('#shoe-finder-step-4');


      var a_buttons = document.querySelectorAll("#shoe-finder-step-4 a.selected");
      if(a_buttons.length > 0){
        console.log("here selected", a_buttons)
        var next_step_button =  document.querySelector('#shoe-finder-step-4.next_step');
        next_step_button.classList.remove('disabled');
      }else{
        var next_step_button =  document.querySelector('#shoe-finder-step-4.next_step');
        next_step_button.classList.add('disabled');

      }

      $('#shoe_finder_gender_filter').empty()
      $('.bc-sf-filter-option-block-gender:not(.bc-sf-filter-option-hidden) .bc-sf-filter-option-swatch.circle-grid').clone().appendTo('#shoe_finder_gender_filter');


    $('#shoe-finder-step-2 .next_step').on("click", function() {
      const parentElement =  $('#slick-slide-control21').parent();
      parentElement.addClass("highlighted");
      $('#shoe-finder-step-4.next_step').removeClass('hidden');
      handleClonedElementClicks()
      $('.shoe_finder_filters').slick('slickNext');
    });

    // level of cushioning step

    $('#shoe-finder-step-4.next_step').on("click", function() {
      const parentElement =  $('#slick-slide-control23').parent();
      parentElement.addClass("highlighted");
      $('.shoe_finder_filters').hide();
      $('#results_final_step').removeClass("hidden");
     // $('.bc-sf-filter-option-block-gender:not(.bc-sf-filter-option-hidden) .bc-sf-filter-option-swatch.circle-grid').clone().appendTo('#shoe_finder_gender_filter');
      console.log("here clicking all cushion", data)

      //handleClonedElementClicks()
      //var originalAfterGetFilterData = BCSfFilter.prototype.afterGetFilterData;
      // BCSfFilter.prototype.afterGetFilterData = function (data) {
      //   // Call the original function first (if needed)
      //   originalAfterGetFilterData.call(this, data);
      //Now, let's attach a callback to it:
      console.log("here after render all:", data)
        const selectedItems = $(".selected-type strong");
        const totalItems = selectedItems.length;
        const resultDiv = $(".result_tags .filters_selected");
        const resultDiv_1 = $(".result_tags .results");
        resultDiv_1.empty();
        resultDiv.empty();
        if (data.total_product > 0){
          $('#shoe_finder_gender_filter').removeClass("hidden");
          $('a[data-id="pf_t_gender"]').on("click", function() {
            const isSelected = $(this).hasClass("selected");
            $('a[data-id="pf_t_gender"]').removeClass("selected");
            if (!isSelected) {
              $(this).addClass("selected");
            } else {
              clearFilterOption(event, this, 'pf_t_gender');
            }
          });
        }
        if (resultDiv_1){
          if (data.total_product > 1){
            resultDiv_1.append(data.total_product + ' Results ' + ' ')
          }else if(data.total_product === 1){
            resultDiv_1.append(data.total_product + ' Result ' + ' ')

          }

        }
        selectedItems.each(function(index) {
            var text = $(this).text().trim();
            var parts = text.split("::");
            if (parts.length > 1) {
              text = parts[1].trim();
            }

            resultDiv.append(text);

            if (index !== totalItems - 1) {
              resultDiv.append(" , ");
            }
            if (index === totalItems - 1) {
              resultDiv.append(" ) ");
            }
            if (index === 0 ) {
              resultDiv.prepend(" ( ");

            }
        });

      //Detach the callback after it has been called once
    //    BCSfFilter.prototype.afterGetFilterData = originalAfterGetFilterData;
    //  };


    });


    }
    handleClonedElementClicks();
  }
  function isMobile() {
    // Check if the screen width is less than a certain threshold (e.g., 768 pixels)
    return window.innerWidth < 1000; // Adjust the threshold as needed
  }

  if (isMobile()) {
    // Code for mobile devices
    const selectedLinks = document.querySelectorAll('.shoe_finder_filters ul.bc-sf-filter-option-box li a.selected');

    // Loop through the selected "a" elements and set the background color of their parent "li" elements
    selectedLinks.forEach(link => {
      link.parentElement.style.backgroundColor = '#333'; // Set your desired background color
      link.parentElement.style.cursor = 'pointer';
      link.parentElement.style.borderColor = '#333';
    });
  }


  var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
  }
  theme.ProductFilter.buildCollectionPage(data, eventType);



  var currentColours = window.bcsffilter.queryParams.pf_t_colour;
  if (currentColours) {
    var lastColour = window.bcsffilter.queryParams.pf_t_colour.slice(-1)[0];
    lastColour = lastColour.replace('colour:', '');
    lastColour = lastColour.replace('colour-', '');
    window.selectedColor = lastColour;
    // jQ("[data-variant-color='"+lastColour.toLowerCase()+"']").addClass("visible");
    // jQ(`[data-variant-swatch-title='${lastColour.toLowerCase()}']`).click();

    if (window.selectedColor) {
      let interval = setInterval(function () {
        jQ(`[data-variant-swatch-title='${window.selectedColor}']`).click();
      }, 300);
      setTimeout(() => { clearInterval(interval) }, 2500);
    }
  }
  
   for (var product of data.products) {
     fetchRelatedProducts(product);
   }

    var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_other + '</span>';
    jQ('#bc-sf-filter-total-product').html(totalProduct);
    if (data.total_product == 1) {
      totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.label.items_with_count_one + '</span>';
    }
    var self = this;
    if (typeof StampedFn !== 'undefined' && typeof StampedFn.loadBadges == 'function' && self.queryParams.event_type !== 'init') {
        StampedFn.loadBadges();
    }

    var currentColours = window.bcsffilter.queryParams.pf_t_colour;
    if(currentColours) {
      var lastColour = window.bcsffilter.queryParams.pf_t_colour.slice(-1)[0];
      lastColour = lastColour.replace('colour:', '');
      console.log("*[data-variant-title*='"+lastColour+"']");
      jQ("*[data-variant-title*='"+lastColour.toLowerCase()+"']").click();
    }
};

function buildEmployeeDiscounts(data) {
  if (!window.location.host == 'kr.wilson.com') return;
  if (data.compare_at_price > 0) {
    if ((data.compare_at_price - data.price) > 0) return;
  }
  console.log( "DATA PRICE" , data.price)
  const customer = window.shop.customer;
  if (!customer.is_logged_in) return;
  

  for (let i=0; i<customer.tags.length; i++) {
    let tag = customer.tags[i];
    if (!tag.includes("discount::") && !tag.includes("%") ) continue;

    let tagSplit = tag.split("::");
    let percent = tagSplit[(tagSplit.length-1)].replace("%","");
    percent = percent/100.0;
    let original_price = data.price;
    let disccounted_price = data.price * percent;

    data.price = original_price - disccounted_price;
    data.compare_at_price = original_price;
    data["employee_discount"] = true;
    console.log("data.compare_at_price" , data.compare_at_price)
  }
}

function addDummyCustomTags(product) {
  if(!window.badges) return [];
  const {compareAtPrice, price, available} = product;
  const saleTag = addSaleTag(compareAtPrice, price, product);
  const soldOutTag = addSoldOutTag(available, product)
  return [...saleTag, ...soldOutTag]
}

function addSaleTag(compareAtPrice, price, product) {
  if(typeof compareAtPrice === 'undefined' || !compareAtPrice) return []
  if(typeof price === 'undefined') return []
  if(compareAtPrice > price) {
    return [window.badges.config.saleDummyTag]
  }
  return []
}


function addSoldOutTag(available, product) {
  if(typeof available === 'undefined') return []
  const boolAvailable = (available === true)
  if (!boolAvailable) {
    return [window.badges.config.soldOutDummyTag]
  }

  return []
}

function buildBadgesLabels(data) {
  const dummyTags = addDummyCustomTags(data)
  const productTags = data.tags.concat(dummyTags);
  const badgesElement = document.getElementById('product-badges');
  if (!badgesElement) {
    return '';
  }
  const badgesJson = JSON.parse(badgesElement.innerHTML);
  const badges = {
    'topLeft': [],
    'topRight': [],
    'bottomLeft': [],
    'bottomRight': []
  };

  for (let index = 0; index < badgesJson.length; index++) {
    const element = badgesJson[index];
    if (productTags.includes(element.id)) {
      var backgroundColor;
      var textColor;
      var hasCustomStyles = false;
      var styles = "style=\"";
      if (element.background_color != "" && element.badge_img == null && element.background_color != "rgba(0,0,0,0)" ) {
        backgroundColor = `background-color: ${element.background_color};`;
        hasCustomStyles = true;
        styles += backgroundColor;
      }
      if (element.text_color != "" && element.text_color != "rgba(0,0,0,0)") {
        textColor = `color: ${element.text_color} !important;`;
        hasCustomStyles = true;
        styles += textColor;
      }
      styles += "\"";
      let img = null
      if (element.badge_img != null) {
        img = `<img class="badge-image" src="${element.badge_img}" />`
      }

      let html = `<span ${styles} class="badge-inner">${img ? img : element.badge_text}</span>`;
      let position = element.position;
      badges[position].push(html);
    }
  }
  data.badges = badges
  // return badgesHtml;
}
function buildHigherDiscountsBW(data) {
  if (!window.location.host == 'kr.wilson.com') return;
  // if (data.compare_at_price > 0) {
  //   if ((data.compare_at_price - data.price) > 0) return;
  // }

  const customer = window.shop.customer;
  if (!customer.is_logged_in) return;
  var birthday_percent= 10;
  var welcome_percent = 10;
  var annual_limit_tag_prefix = 'annual-limit::'
  var annual_expense_tag_prefix = 'annual-expense::'
  var staff_dicount = 'discount::';
  var loyalty_tag_prefix = 'Membership::Tier::';
  var loyalty_gold_percentage = 10;
  var loyalty_silver_percentage = 5;
  var loyalty = false;
  var birthday = false;
  var b_claimed = false;
  var b_expired = false;
  var welcome = false;
  var claimed = false;
  var expired = false;
  var price = data.price;
  var member_discount = 0;

  for (let i=0; i<customer.tags.length; i++) {
    let tag = customer.tags[i];
    if (tag.includes("birthday-discount::created")){
      birthday = true;
    }else if (tag.includes("welcome-discount::created")){
        welcome = true;
    } else if(tag.includes("welcome-discount::claimed")){
        claimed = true;
    }else if( tag.includes("welcome-discount::expired")){
      expired = true;
    }else if(tag.includes("birthday-discount::claimed")){
       b_claimed = true;
    }else if( tag.includes("birthday-discount::expired")){
      b_expired = true;
    }else if( tag.includes(loyalty_tag_prefix)){
      var tier_name = tag.split('::')[2]
      var loyalty_discount = 0
      switch (tier_name) {
        case  "Gold":
          loyalty_discount = loyalty_gold_percentage;
          loyalty = true;
          // console.log("TIER NAME", tier_name)
          break;
        case "Silver":
          loyalty_discount = loyalty_silver_percentage;
          loyalty = true;
          // console.log("TIER NAME", tier_name)
          break;
        default:
          loyalty_discount = 0;
      }
    }else if( tag.includes(staff_dicount) && tag.includes("%")){
        let tagSplit = tag.split("::");
        var staff_percentage = tagSplit[(tagSplit.length-1)].replace("%","");
        // console.log("percent", staff_percentage)

    }else if( tag.includes(annual_limit_tag_prefix) ){
      let tagSplit = tag.split("::")[2];
      // console.log("annual_limit tag", tagSplit)
      var annual_limit = tagSplit;
      // console.log("annual_limit", annual_limit)
    }else if( tag.includes(annual_expense_tag_prefix) ){
      let tagSplit = tag.split("::")[2];
      var annual_expense = tagSplit;
      // console.log("annual_expense", annual_expense)
    }
  }

  if ( annual_expense  && annual_limit  && staff_percentage){
    var memeber_total_left = annual_limit - annual_expense
    if (memeber_total_left > 0 && staff_percentage > 0) {
     var member_qualifies = true
    }
  }


  if ( welcome == true && claimed == false && expired == false){
    if ( welcome_percent > member_discount){
      member_discount = welcome_percent;
    }
      let percent;
      percent = member_discount/100.0;
      let original_price = price;
      let disccounted_price = original_price * percent;

      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["welcome_discount"] = true;

      // console.log("Welcome qualifies ")
  }
 if(birthday == true && b_claimed == false && b_expired == false ){
  if(birthday_percent > member_discount){
    member_discount = birthday_percent;
  }

      let percent;
      percent = member_discount/100.0;
      let original_price = price;
      let disccounted_price = original_price * percent;

      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["birthday_discount"] = true;

    // console.log("Birthday  qualifies ")
  }

  if(loyalty == true){
    if(loyalty_discount > member_discount){
      member_discount = loyalty_discount;
    }
    percent = member_discount/100.0;
    let original_price = data.price;
    if (data.compare_at_price > 0) {
      original_price = data.compare_at_price;
    }
    let disccounted_price = original_price * percent;

    let standardDiscount = original_price - price;
    let memberDiscount = original_price - disccounted_price;
    if (standardDiscount>disccounted_price) return;

    data.price = memberDiscount;
    data.compare_at_price = original_price;
    data["Loyalty_discount"] = true;
  }

  if (member_qualifies == true){
    if(staff_percentage > member_discount){
      member_discount = staff_percentage;
    }

    percent = member_discount/100.0;
    let original_price = data.price;
    if (data.compare_at_price > 0) {
      original_price = data.compare_at_price;
    }
    let disccounted_price = original_price * percent;

    let standardDiscount = original_price - price;
    let memberDiscount = original_price - disccounted_price;
    console.log("standardDiscount", standardDiscount);
    console.log("disccounted_price", disccounted_price);
    if (standardDiscount>disccounted_price) return;

    data.price = memberDiscount;
    data.compare_at_price = original_price;
    data["Staff_discount"] = true;
  }
}
function buildDiscounts(data) {
  if (!window.location.host == 'salomon.co.kr') return;
  if (data.compare_at_price > 0) {
    if ((data.compare_at_price - data.price) > 0) return;
  }

  const customer = window.shop.customer;
  if (!customer.is_logged_in) return;
  var birthday_percent= 10;
  var welcome_percent = 10;
  var annual_limit_tag_prefix = 'annual-limit::'
  var annual_expense_tag_prefix = 'annual-expense::'
  var staff_dicount = 'discount::';
  var loyalty_tag_prefix = 'Membership::Tier::';
  var loyalty_gold_percentage = 7;
  var loyalty_silver_percentage = 5;
  var loyalty = false;
  var birthday = false;
  var b_claimed = false;
  var b_expired = false;
  var welcome = false;
  var claimed = false;
  var expired = false;
  var price = data.price;
  var member_discount = 0;

  for (let i=0; i<customer.tags.length; i++) {
    let tag = customer.tags[i];
    if (tag.includes("birthday-discount::created")){
      birthday = true;
    }else if (tag.includes("welcome-discount::created")){
        welcome = true;
    } else if(tag.includes("welcome-discount::claimed")){
        claimed = true;
    }else if( tag.includes("welcome-discount::expired")){
      expired = true;
    }else if(tag.includes("birthday-discount::claimed")){
       b_claimed = true;
    }else if( tag.includes("birthday-discount::expired")){
      b_expired = true;
    }else if( tag.includes(loyalty_tag_prefix)){
      var tier_name = tag.split('::')[2]
      var loyalty_discount = 0
      switch (tier_name) {
        case  "Gold":
          loyalty_discount = loyalty_gold_percentage;
          loyalty = true;
          // console.log("TIER NAME", tier_name)
          break;
        case "Silver":
          loyalty_discount = loyalty_silver_percentage;
          loyalty = true;
          // console.log("TIER NAME", tier_name)
          break;
        default:
          loyalty_discount = 0;
      }
    }else if( tag.includes(staff_dicount) && tag.includes("%")){
        let tagSplit = tag.split("::");
        var staff_percentage = tagSplit[(tagSplit.length-1)].replace("%","");
        // console.log("percent", staff_percentage)

    }else if( tag.includes(annual_limit_tag_prefix) ){
      let tagSplit = tag.split("::")[1];
      // console.log("annual_limit tag", tagSplit)
      var annual_limit = tagSplit;
      // console.log("annual_limit", annual_limit)
    }else if( tag.includes(annual_expense_tag_prefix) ){
      let tagSplit = tag.split("::")[1];
      var annual_expense = tagSplit;
      // console.log("annual_expense", annual_expense)
    }
  }

  if ( annual_expense  && annual_limit  && staff_percentage){
    var memeber_total_left = annual_limit - annual_expense
    if (memeber_total_left > 0 && staff_percentage > 0) {
     var member_qualifies = true
    }

  }


  if ( welcome == true && claimed == false && expired == false){
      if ( welcome_percent > member_discount){
        member_discount = welcome_percent;
      }
      let percent;
      percent = member_discount/100.0;
      let original_price = price;
      let disccounted_price = original_price * percent;

      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["welcome_discount"] = true;

      console.log("Welcome qualifies ")
  }
 if(birthday == true && b_claimed == false && b_expired == false ){

    if(birthday_percent > member_discount){
      member_discount = birthday_percent;
    }
      let percent;
      percent = member_discount/100.0;
      let original_price = price;
      let disccounted_price = original_price * percent;

      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["birthday_discount"] = true;

    // console.log("Birthday  qualifies ")
  }
  if(loyalty == true){


    if(loyalty_discount > member_discount){
      member_discount = loyalty_discount;
    }
    percent = member_discount/100.0;
    let original_price = price;
    let disccounted_price = original_price * percent;

    data.price = original_price - disccounted_price;
    data.compare_at_price = original_price;
    data["Loyalty_discount"] = true;


  }
  if (member_qualifies == true){
    if(staff_percentage > member_discount){
      member_discount = staff_percentage;
    }
      percent = member_discount/100.0;
      let original_price = price;
      let disccounted_price = original_price * percent;

      data.price = original_price - disccounted_price;
      data.compare_at_price = original_price;
      data["Staff_discount"] = true;

      // console.log("Member qualifies ")

  }


}



// Build Default layout
function buildDefaultLink(a, b) {
    var c = window.location.href.split("?")[0];
    return c += "?" + a + "=" + b
}
BCSfFilter.prototype.buildDefaultElements = function (a) {
    if (bcSfFilterConfig.general.hasOwnProperty("collection_count") && jQ("#bc-sf-filter-bottom-pagination").length > 0) {
        var b = bcSfFilterConfig.general.collection_count,
            c = parseInt(this.queryParams.page),
            d = Math.ceil(b / this.queryParams.limit);
        if (1 == d)
            return jQ(this.selector.pagination).html(""),
            !1;

        if ("default" == this.getSettingValue("general.paginationType")) {
            var e = bcSfFilterTemplate.paginateHtml,
                f = "";
            f = c > 1 ? bcSfFilterTemplate.hasOwnProperty("previousActiveHtml") ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousHtml : bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml") ? bcSfFilterTemplate.previousDisabledHtml : "",
            f = f.replace(/{{itemUrl}}/g, buildDefaultLink("page", c - 1)),
            e = e.replace(/{{previous}}/g, f);
            var g = "";
            g = c < d ? bcSfFilterTemplate.hasOwnProperty("nextActiveHtml") ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextHtml : bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml") ? bcSfFilterTemplate.nextDisabledHtml : "",
            g = g.replace(/{{itemUrl}}/g, buildDefaultLink("page", c + 1)),
            e = e.replace(/{{next}}/g, g);
            for (var h =[], i = c - 1; i > c - 3 && i > 0; i--)
                h.unshift(i);

            c - 4 > 0 && h.unshift("..."),
            c - 4 >= 0 && h.unshift(1),
            h.push(c);
            for (var j =[], k = c + 1; k < c + 3 && k <= d; k++)
                j.push(k);

            c + 3 < d && j.push("..."),
            c + 3 <= d && j.push(d);
            for (var l = "", m = h.concat(j), n = 0; n < m.length; n++)
                "..." == m[n] ? l += bcSfFilterTemplate.pageItemRemainHtml : l += m[n] == c ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml,
                l = l.replace(/{{itemTitle}}/g, m[n]),
                l = l.replace(/{{itemUrl}}/g, buildDefaultLink("page", m[n]));

            e = e.replace(/{{pageItems}}/g, l),
            jQ(this.selector.pagination).html(e)
        }
    }
    if (bcSfFilterTemplate.hasOwnProperty("sortingHtml") && jQ(this.selector.topSorting).length > 0) {
        jQ(this.selector.topSorting).html("");
        var o = this.getSortingList();
        if (o) {
            var p = "";
            for (var q in o)
                p += '<option value="' + q + '">' + o[q] + "</option>";

            var r = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, p);
            jQ(this.selector.topSorting).html(r);
            var s = void 0 !== this.queryParams.sort_by ? this.queryParams.sort_by : this.defaultSorting;
            jQ(this.selector.topSorting + " select").val(s),
            jQ(this.selector.topSorting + " select").change(function (a) {
                window.location.href = buildDefaultLink("sort_by", jQ(this).val())
            })
        }
    }
};


/* Customize data to suit the data of Shopify API */
BCSfFilter.prototype.prepareProductData = function (data) {
  var countData = data.length;
  for (var k = 0; k < countData; k++) {
    data[k]['images'] = data[k]['images_info'];
    if (data[k]['images'].length > 0) {
      data[k]['featured_image'] = data[k]['images'][0]
      
      if (data[k]['images'].length === 1 && data[k]['original_images'] && data[k]['original_images'].length > 1 ) {
        data[k]['second_image'] = data[k]['original_images'][1]
      } else if(data[k]['images'].length > 1) {
        data[k]['second_image'] = data[k]['images'][1]
      }
    } else {
      data[k]['featured_image'] = {
        src: bcSfFilterConfig.general.no_image_url,
        width: '',
        height: '',
        aspect_ratio: 0
      }
    }
    data[k]['url'] = '/products/' + data[k].handle;
    var optionsArr = [];
    var countOptionsWithValues = data[k]['options_with_values'].length;
    for (var i = 0; i < countOptionsWithValues; i++) {
      optionsArr.push(data[k]['options_with_values'][i]['name'])
    }
    data[k]['options'] = optionsArr;
    data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;
    data[k]['price'] = data[k]['price_min'];
    data[k]['compare_at_price'] = data[k]['compare_at_price_min'];
    data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];
    data[k]['type'] = data[k]['product_type'];
    var firstVariant = data[k]['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == getParam('variant')
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      var countVariants = data[k]['variants'].length;
      for (var i = 0; i < countVariants; i++) {
        if (data[k]['variants'][i].available) {
          firstVariant = data[k]['variants'][i];
          break
        }
      }
    }
    data[k]['selected_or_first_available_variant'] = firstVariant;
    var countVariants = data[k]['variants'].length;
    for (var i = 0; i < countVariants; i++) {
      var variantOptionArr = [];
      var count = 1;
      var variant = data[k]['variants'][i];
      var variantOptions = variant['merged_options'];
      if (Array.isArray(variantOptions)) {
        var countVariantOptions = variantOptions.length;
        for (var j = 0; j < countVariantOptions; j++) {
          var temp = variantOptions[j].split(':');
          data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
          data[k]['variants'][i]['option_' + temp[0]] = temp[1];
          variantOptionArr.push(temp[1])
        }
        data[k]['variants'][i]['options'] = variantOptionArr

      }
      data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
      data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100
    }
    data[k]['description'] = data[k]['content'] = data[k]['body_html'];
    /* Start Multi currency data */
    /* If this store has the multi-currency feature */
    if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {
      /* Get the current currency code */
      var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();

      /* Update the product price data */
      data[k].price_min = data[k]['price_min_' + currentCurrency];
      data[k].price_max = data[k]['price_max_' + currentCurrency];
      data[k].compare_at_price_min = data[k]['compare_at_price_min_' + currentCurrency];
      data[k].compate_at_price_max = data[k]['compare_at_price_max_' + currentCurrency];
    }
    /* End Multi currency data */

    buildBadgesLabels(data[k]);
    //buildDiscounts(data[k]);
    buildD2XDiscounts(data[k]);
    buildHigherDiscountsBW(data[k]);
  }
  return data
};

class D2XAndFOCDiscounts {
  constructor(product) {
    this.product = product;
    this.customer = window.shop.customer_d2x;

    this.d2x_metafield_discount = this.customer.d2x_metafield_discount
    this.d2x_metafield_limit = this.customer.d2x_metafield_limit
    this.d2x_metafield_expense = this.customer.d2x_metafield_expense
    this.foc_metafield_discount = this.customer.foc_metafield_discount
    this.foc_metafield_limit = this.customer.foc_metafield_limit
    this.foc_metafield_expense = this.customer.foc_metafield_expense
    this.is_customer = this.customer.is_customer

    this.customer_has_d2x_discount = this.defineCustomerD2Xdiscount();
    this.customer_has_foc_discount = this.defineCustomerFOCdiscount();


    this.is_d2x_discount = false;
    this.is_foc_discount = false;
    this.product_has_discount = false;
    this.product_has_d2x_discount = false;
    this.product_has_foc_discount = false;

    this.product_foc_discounts = [];
    this.product_d2x_discounts = [];
    this.foc_metafield_discount_array = [];
    this.foc_metafield_discount_array = [];
  }

  result() {
    if (!this.customer) {
        return this.product;
    }


    if (!this.customer_has_d2x_discount && !this.customer_has_foc_discount) {
      return this.product;
    }

    this.defineProductDiscounts();

    this.product_has_d2x_discount = !!this.product_d2x_discounts.length
    this.product_has_foc_discount = !!this.product_foc_discounts.length
    this.product_has_discount = this.product_has_d2x_discount && this.product_has_foc_discount

    if (!this.product_has_d2x_discount && !this.product_has_foc_discount) {
      return this.product;
    }

    this.d2x_metafield_discount_array = this.d2x_metafield_discount?.split(',')?.map(el => el.trim())
    this.foc_metafield_discount_array = this.foc_metafield_discount?.split(',')?.map(el => el.trim())

    this.defineLimits();
    this.defineDiscounts();
    this.d2x_percent_discount = this.getD2XDiscount();

    if (this.is_foc_discount) {
      this.modifyProductWithFOCDiscount();
    }

    if (this.is_d2x_discount && !this.is_foc_discount) {
      this.modifyProductWithD2XDiscount();
    }

    return this.product;


  }

  modifyProductWithFOCDiscount() {
    const {price,compare_at_price} = this.product;

    const sale_discount = compare_at_price - price

    if (sale_discount > this.foc_different) {
      return null
    }

    let resultPrice = price - this.foc_different

    if (compare_at_price && compare_at_price > 0 && this.foc_different > sale_discount ) {
      resultPrice = compare_at_price - this.foc_different
    } else {
      this.product.compare_at_price = price
    }

    resultPrice > 0 ? this.product.price = resultPrice : this.product.price = 0

  }

  modifyProductWithD2XDiscount() {
    const {price,compare_at_price} = this.product;

    const sale_discount = compare_at_price - price

    if (compare_at_price && compare_at_price > 0) {
      let discount = compare_at_price * this.d2x_percent_discount / 100

      if (discount > this.d2x_different) {
         discount = this.d2x_different
      }

      if (sale_discount > discount) {
        return null;
      }

      this.product.price = compare_at_price - discount


    } else {

      let discount = price * this.d2x_percent_discount / 100

      if (discount > this.d2x_different) {
        discount = this.d2x_different
      }

      this.product.price = price - discount
      this.product.compare_at_price = price
    }

  }

  defineCustomerD2Xdiscount () {
    return !!(this.d2x_metafield_discount && this.d2x_metafield_limit && this.d2x_metafield_expense)
  }

  defineCustomerFOCdiscount() {
    return !!(this.foc_metafield_discount && this.foc_metafield_limit && this.foc_metafield_expense)
  }

  defineProductDiscounts() {

    let metafield = this.product.metafields.find(el => el.namespace === 'd2x_foc' && el.key === 'discount_type')


    if(!metafield) {
      return null
    }

    let tags = metafield?.value?.split(',')?.map(el => el.trim())


    this.product_foc_discounts = tags.filter(tag => {
        return tag.includes('foc::')
      })

    this.product_d2x_discounts = tags.filter(tag => {
      return tag.includes('discount::')
    })

    // const {tags} = this.product;
    //
    // this.product_foc_discounts = tags.filter(tag => {
    //     return tag.includes('foc::')
    //   })
    //
    // this.product_d2x_discounts = tags.filter(tag => {
    //   return tag.includes('discount::')
    // })


  }

  defineLimits() {
    this.foc_different = (this.foc_metafield_limit - this.foc_metafield_expense) * 100.0
    this.d2x_different = (this.d2x_metafield_limit - this.d2x_metafield_expense) * 100.0
  }

  defineDiscounts() {

    const FOC_compare = this.foc_metafield_discount_array?.some(v => v.includes(this.product_foc_discounts)) || false
    const D2X_compare = this.d2x_metafield_discount_array?.some(v => v.includes(this.product_d2x_discounts)) || false

    this.is_d2x_discount = !!(this.product_has_d2x_discount && this.d2x_different > 0 && this.customer_has_d2x_discount && D2X_compare)
    this.is_foc_discount = !!(this.product_has_foc_discount && this.foc_different > 0 && this.customer_has_foc_discount && FOC_compare)
  }

  getD2XDiscount() {
   const D2X_metafield = this.d2x_metafield_discount_array?.find(v => v.includes(this.product_d2x_discounts))

    if (D2X_metafield) {
      let tag = D2X_metafield.split('::')
      return parseInt(tag.pop())
    }

    return null;
  }
}

function buildD2XDiscounts(product) {

  const getDiscount = new D2XAndFOCDiscounts(product);

  return getDiscount.result();
}

BCSfFilter.prototype.buildToggleEvent = function (a) {

  var b = this, c = this.class.filterOptionOpenList, d = this.class.filterOptionCloseList,
    e = this.class.filterOption, f = jQ("." + c).length > 0 ? jQ("." + c).val().split(",") : [],
    g = jQ("." + d).length > 0 ? jQ("." + d).val().split(",") : [];
    let thisFilter = $("." + this.class.filterBlockTitle);
    let closeIcon = document.createElement('div');
    closeIcon.className = "close-icon";
    closeIcon.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.822633 1.17737C0.432109 1.56789 0.43211 2.20106 0.822634 2.59158L5.63095 7.3999L0.82263 12.2082C0.432106 12.5987 0.432106 13.2319 0.82263 13.6224C1.21315 14.013 1.84632 14.013 2.23684 13.6224L7.04516 8.81411L11.8535 13.6224C12.244 14.013 12.8772 14.013 13.2677 13.6224C13.6582 13.2319 13.6582 12.5988 13.2677 12.2082L8.45938 7.3999L13.2677 2.59157C13.6582 2.20104 13.6582 1.56788 13.2677 1.17736C12.8772 0.786831 12.244 0.786834 11.8535 1.17736L7.04516 5.98568L2.23685 1.17737C1.84632 0.786842 1.21316 0.786842 0.822633 1.17737Z" fill="black"/></svg>';
  $(".bc-sf-filter-block-content").append(closeIcon);


  $(".bc-sf-filter-option-block").removeClass('content-show');

  jQ(".bc-sf-filter-option-block").on("click", function (b) {
    $(".bc-sf-filter-option-block").addClass('content-show');
  })

  jQ(".close-icon").on("click", function (a) {
    $(".bc-sf-filter-block-content").hide();
    $(".bc-sf-filter-block-title span").addClass('up');
    $("body").removeClass('offset-right');
    $("body").removeClass('offset-left');
  })

  jQ("." + this.class.filterBlockTitle + " h3").on("click", function (a) {
    a.preventDefault();

    let self = this;
    let option = $(self).closest('.bc-sf-filter-option-block');
    $(option).siblings().not($(option)).find('.bc-sf-filter-block-title span').addClass('up');
    thisFilter.each(function() {
        $(".bc-sf-filter-block-content").hide();
        $(this).find(".bc-sf-filter-block-content").show();
    });


    let offsetLink = jQ(this).offset().left;
    if(offsetLink > 50){
      $("body").addClass('offset-right');
      $("body").removeClass('offset-left');
    }
    else{
      $("body").addClass('offset-left');
      $("body").removeClass('offset-right');
    }

    var h = jQ(this).closest("." + e).attr("data-id");
    jQ(this).children().hasClass("up") ? (b.getSettingValue("general.keepToggleState") && (f.push(h), g.length > 0 && g.indexOf(h) > -1 && g.splice(g.indexOf(h), 1)), jQ(this).children().removeClass("up"), jQ(this).parent().siblings().slideDown(function () {
      "range" != jQ(this).parent().attr("data-display-type") && (b.buildFilterOptionBoxStyle(jQ(this)), b.buildFilterScrollbar(this))
    })) : (b.getSettingValue("general.keepToggleState") && (g.push(h), f.length > 0 && f.indexOf(h) > -1 && f.splice(g.indexOf(h), 1)), jQ(this).children().addClass("up"), jQ(this).parent().siblings().slideUp()), jQ("." + c).val(f.join(",")), jQ("." + d).val(g.join(","))
  }), this.getSettingValue("general.collapseSubCategory") && jQ("." + this.class.filterOption + ".bc-sf-filter-option-block-sub_category .bc-sf-filter-option-single-list li span.sub-icon").on("click", function (a) {
    jQ(this).hasClass("sub-up") ? (jQ(this).removeClass("sub-up"), jQ(this).parent().siblings().slideDown()) : (jQ(this).addClass("sub-up"), jQ(this).parent().siblings().slideUp())

    if(!$(self).find("span").hasClass('up')){
      $(self).find("span").addClass('up');
    }

  })
}



BCSfFilter.prototype.getFilterData = function (eventType, errorCount) {
    function BCSend(eventType, errorCount) {
        var self = bcsffilter;
        var errorCount = typeof errorCount !== "undefined" ? errorCount : 0;
        self.showLoading();
        if (typeof self.buildPlaceholderProductList == "function") {
            self.buildPlaceholderProductList(eventType)
        }
        self.beforeGetFilterData(eventType);
        self.prepareRequestParams(eventType);
        self.queryParams["callback"] = "BCSfFilterCallback";
        self.queryParams["event_type"] = eventType;
        var url = self.isSearchPage() ? self.getApiUrl("search") : self.getApiUrl("filter");
        var script = document.createElement("script");
        script.type = "text/javascript";
        var timestamp = (new Date).getTime();
        script.src = url + "?t=" + timestamp + "&" + jQ.param(self.queryParams);
        script.id = "bc-sf-filter-script";
        script.async = true;
        var resendAPITimer,
            resendAPIDuration;
        resendAPIDuration = 2e3;
        script.addEventListener("error", function (e) {
            if (typeof document.getElementById(script.id).remove == "function") {
                document.getElementById(script.id).remove()
            } else {
                document.getElementById(script.id).outerHTML = ""
            }
            if (errorCount < 3) {
                errorCount++;
                if (resendAPITimer) {
                    clearTimeout(resendAPITimer)
                }
                resendAPITimer = setTimeout(self.getFilterData("resend", errorCount), resendAPIDuration)
            } else {
                self.buildDefaultElements(eventType)
            }
        });
        document.getElementsByTagName("head")[0].appendChild(script);
        script.onload = function () {
            if (typeof document.getElementById(script.id).remove == "function") {
                document.getElementById(script.id).remove()
            } else {
                document.getElementById(script.id).outerHTML = ""
            }
        }
    }
    this.requestFilter(BCSend, eventType, errorCount)

};
BCSfFilter.prototype.requestFilter = function (sendFunc, eventType, errorCount) {

    sendFunc(eventType, errorCount)
};




/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem = function (html, iLabel, iValue, fOType, fOId, fOLabel, fODisplayType, fOSelectType, fOItemValue, fOData) {
    var keepValuesStatic = fOData.hasOwnProperty("keepValuesStatic") ? fOData.keepValuesStatic : false;
    if (fOType == "review_ratings" && this.getSettingValue("general.ratingSelectionStyle") == "text") {
        var title = this.getReviewRatingsLabel(fOItemValue.from)
    } else {
        var title = this.customizeFilterOptionLabel(iLabel, fOData.prefix, fOType)
    }
    if (keepValuesStatic === true)
        var productNumber = null;
     else
        var productNumber = fOItemValue.hasOwnProperty("doc_count") ? fOItemValue.doc_count : 0;
     html = html.replace(/{{itemLabel}}/g, this.buildFilterOptionLabel(iLabel, productNumber, fOData));
    html = html.replace(/{{itemLink}}/g, this.buildFilterOptionLink(fOId, iValue, fOType, fODisplayType, fOSelectType, keepValuesStatic));
    html = html.replace(/{{itemValue}}/g, encodeURIParamValue(iValue));
    html = html.replace(/{{itemTitle}}/g, title);
    html = html.replace(/{{itemFunc}}/g, "onInteractWithFilterOptionValue(event, this, '" + fOType + "', '" + fODisplayType + "', '" + fOSelectType + "', '" + keepValuesStatic + "')");
    html = this.checkFilterOptionSelected(fOId, iValue, fOType, fODisplayType) ? html.replace(/{{itemSelected}}/g, "selected") : html.replace(/{{itemSelected}}/g, "");
    var htmlElement = jQ(html);
    htmlElement.children().attr({
        "data-id": fOId,
        "data-value": encodeURIParamValue(iValue),
        "data-parent-label": fOLabel,
        "data-title": title,
        "data-count": productNumber
    });
    if (fOType != "collection") {
        htmlElement.children().attr("rel", "nofollow")
    }
    if (fOType == "collection") {}
        htmlElement.children().attr("data-collection-scope", fOItemValue.key);


    //console.log("build Elements: ", fOId)




  return jQ(htmlElement)[0].outerHTML


};

/* end-boost-2.4.8 */


